import { Log, User, UserManager, UserManagerSettings } from 'oidc-client'
import { createUserManager } from 'redux-oidc'

import { Env, getEnv } from '@cinch/oxd-utils/env/src'

import getStore from './user-store'

export { User, UserManager }

const settings: UserManagerSettings = {
  userStore: getStore(),
  authority: getEnv(Env.AuthAuthority),
  client_id: getEnv(Env.AuthClientId),
  redirect_uri: getEnv(Env.AuthRedirect),
  post_logout_redirect_uri: getEnv(Env.SiteUrl),
  response_type: 'code',
  scope: 'openid email idt prf dd',
  silent_redirect_uri: `${getEnv(Env.SiteUrl)}/silent-renew`,
  automaticSilentRenew: true,
  includeIdTokenInSilentRenew: true,
  filterProtocolClaims: true,
  monitorSession: false,
  loadUserInfo: true,
}

const userManager = createUserManager(settings)

if (getEnv(Env.Env) === 'development') {
  Log.logger = console
}

export default userManager
